import { NavLink as MantineNavLink, type NavLinkProps } from "@mantine/core";
import { createLink, type LinkComponent } from "@tanstack/react-router";
import * as React from "react";
import { globalConfig } from "~/consts/config";

interface NavLinkTSRProps extends Omit<NavLinkProps, "href"> {
  // Add any additional props you want to pass to the NavLink
}

const MantineLinkComponent = React.forwardRef<HTMLAnchorElement, NavLinkTSRProps>((props, ref) => {
  return <MantineNavLink ref={ref} {...props} />;
});

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const NavLink: LinkComponent<typeof MantineLinkComponent> = (props) => {
  return <CreatedLinkComponent preload={globalConfig.preloadStrategy} {...props} />;
};
